import { createFileRoute } from "@tanstack/react-router"
import { AdminRoute } from "@/app"

export const Route = createFileRoute("/(user)/admin")({
  component: RouteComponent,
})

function RouteComponent() {
  return <AdminRoute />
}
